import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import Form from "./components/Form";
import Tracking from "assets/images/Tracking.png";

const LoginPage = () => {
  const { palette } = useTheme();
  const isLargeScreen = useMediaQuery("(min-width: 1000px)");
  const backgroundAlt = palette.background.alt;

  return (
    <Box
      sx={{
        backgroundImage: `url(${Tracking})`, // Sets the background image
        backgroundSize: "cover", // This ensures the image covers the entire area
        backgroundPosition: "center", // This centers the image
        minHeight: "100vh", // Sets a minimum height to cover the viewport
        display: "flex", // Allows for content alignment
        flexDirection: "column", // Aligns children in a column
      }}
    >
      <Box
        width="100%"
        backgroundColor={backgroundAlt}
        p="1rem 6%"
        textAlign="center"
      >
        <Typography color="primary" variant="h1">
          ALT Coach
        </Typography>
      </Box>

      <Box
        width={isLargeScreen ? "50%" : "93%"}
        p="2rem"
        m="2rem auto"
        borderRadius="1.5rem"
        backgroundColor={backgroundAlt}
        data-testid="box"
      >
        <Typography fontWeight="500" variant="h5" sx={{ mb: "1.5rem" }}>
          Welcome to ALT Coach. Please login to continue.
        </Typography>
        <Form />
      </Box>
    </Box>
  );
};

export default LoginPage;
